import { useState, useEffect, useRef } from "react";
import Slide from "./Slide";
import styles from "./Testimonial.module.css";
import testimonialData from "./TestimonialData";
import useIsInViewportOnce from "../../utils/hooks/useIsInViewportOnce";

const Testimonial = () => {
  const sectionRef = useRef();
  const isInViewportOnce = useIsInViewportOnce(sectionRef);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const lastIndex = testimonialData.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, testimonialData]);

  useEffect(() => {
    const slider = setInterval(() => {
      setIndex(index + 1);
    }, 6000);

    return () => clearInterval(slider);
  }, [index]);

  return (
    <section id="clients" className={styles.testimonial} ref={sectionRef}>
      <div className="container">
        <div
          className={`${styles.heading} ${
            isInViewportOnce ? "useSlideInLeft" : "useSlideInLeftEnter"
          }`}
        >
          <h4>Click on my name</h4>
          <h1>About Me</h1>
        </div>
        <div className={styles.pagination}>
          {testimonialData.map((key) => (
            <span
              key={key.id}
              className={`${styles["pagination-dot"]} ${
                key.id === index ? styles["pagination-dot--active"] : ""
              }`}
            />
          ))}
        </div>
        <div className={styles.slider}>
          {testimonialData.map((data) => (
            <Slide
              data={data}
              valueIndex={data.id}
              key={data.id}
              index={index}
              dataLength={testimonialData.legth}
            />
          ))}

          <div className={styles.slideButtons}>
            <a
              className={styles.sliderBtnl}
              href="https://github.com/jonathan20dev"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-github-alt" />
            </a>
            <a
              className={styles.sliderBtnr}
              href="https://www.linkedin.com/in/jonathan-mendoza20/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-linkedin-square" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
